import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import ServiceRowMobile from '../components/ServiceRowMobile'
import ServiceRowBroadband from '../components/ServiceRowBroadband'
import store from '../store'
import ServiceRow from '../components/ServiceRow'
import ServiceRowPhone from '../components/ServiceRowPhone'

class MyServicesList extends React.Component {
    render () {
        return (
            <div className='my-services module'>
                <Heading title='My services'>
                    <div className='col-md-7 col-12 mt-md-0 mt-2 d-flex align-items-center justify-content-md-end'>
                        <span>Customer ID: <span className='bold'>{store.getState().auth.id}</span></span>
                    </div>
                </Heading>
                <ModuleWithLoader isLoaded={this.props.isLoaded} hasError={this.props.hasError}>
                    {this.props.broadband.map((item, key) => {
                        return <ServiceRowBroadband key={key} item={item} />
                    })}
                    {this.props.mobile.map((item, key) => {
                        return <ServiceRowMobile key={key} item={item} />
                    })}
                    {this.props.phone.map((item, key) => {
                        return <ServiceRowPhone key={key} item={item} />
                    })}
                    <ServiceRow
                        icon='/images/icon-binoculars.svg'
                        title='Can’t see a service?'
                        subTitle='Maybe it has its own account'
                        noUrl
                        closable
                        closableKey='cant-see-service'
                    >
                        <div className='h-100 d-flex align-items-center'>
                            <span>If you can’t see a particular service here, it is most likely because it was created as a separate account when you ordered the service.  You can merge accounts, so you can track all your services under the one My Exetel login, by calling our Billings Team on <a href='tel:133938' className='bold'>13 39 38</a></span>
                        </div>
                    </ServiceRow>
                </ModuleWithLoader>
            </div>
        )
    }
}

MyServicesList.propTypes = {
    broadband: PropTypes.array.isRequired,
    mobile: PropTypes.array.isRequired,
    phone: PropTypes.array.isRequired,
    hasError: PropTypes.bool,
    isLoaded: PropTypes.bool
}

export default MyServicesList



// WEBPACK FOOTER //
// ./resources/js/modules/MyServicesList.js